import { render } from "./next-arrow.vue?vue&type=template&id=0468a684&scoped=true"
import script from "./next-arrow.vue?vue&type=script&lang=js"
export * from "./next-arrow.vue?vue&type=script&lang=js"

import "./next-arrow.vue?vue&type=style&index=0&id=0468a684&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0468a684"]])

export default __exports__